import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { 
  FaArrowLeft, 
  FaCalendarAlt, 
  FaShareAlt 
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../axios/api";

const NoticiaDetalhes = () => {
  const { id } = useParams();
  const [noticia, setNoticia] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchNoticiaDetalhes = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/noticias/${id}`);
        const dadosNoticia = res.data.data || res.data;
        
        if (isMounted) {
          setNoticia(dadosNoticia);
          setLoading(false);
        }
      } catch (err) {
        console.error("Erro ao carregar detalhes da notícia:", err);
        if (isMounted) {
          setError("Não foi possível carregar os detalhes da notícia.");
          setLoading(false);
        }
      }
    };

    if (id) {
      fetchNoticiaDetalhes();
    }
    return () => { isMounted = false; };
  }, [id]);

  if (loading) {
    return (
      <main className="bg-white text-dark min-vh-100 d-flex flex-column">
        <Header />
        <div className="container py-5 my-auto text-center">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="text-muted mt-3">A carregar os detalhes da notícia...</p>
        </div>
        <Footer />
      </main>
    );
  }

  if (error || !noticia || noticia.status === 0 || noticia.status === "0" || noticia.status === false) {
    return (
      <main className="bg-white text-dark min-vh-100 d-flex flex-column">
        <Header />
        <div className="container py-5 my-auto text-center">
          <div className="alert alert-warning py-4 rounded-4 shadow-sm border-0 d-inline-block px-5">
            <h4 className="fw-bold text-dark mb-2">Notícia não encontrada</h4>
            <p className="text-muted mb-4">A notícia que procura pode ter sido removida ou não está disponível.</p>
            <Link to="/noticias" className="btn btn-dark text-warning">
              <FaArrowLeft className="me-2" /> Voltar para Notícias
            </Link>
          </div>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main className="bg-white text-dark">
      <Header />

      {/* Breadcrumb / Top Bar */}
      <section className="bg-light py-3 border-bottom">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <Link to="/noticias" className="text-decoration-none text-muted small d-flex align-items-center gap-2 fw-semibold">
              <FaArrowLeft /> Voltar para o Blog
            </Link>
            <span className="text-muted small">
              Início &gt; Notícias &gt; <span className="text-dark fw-semibold">{noticia.titulo}</span>
            </span>
          </div>
        </div>
      </section>

      {/* Article Content Section */}
      <section className="py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              
              {/* Category / Badge */}
              <div className="mb-3">
                <span className="badge bg-warning text-dark px-3 py-2 fw-bold text-uppercase rounded-pill">
                  {noticia.categoria || "Notícia"}
                </span>
              </div>

              {/* Title */}
              <h1 className="display-5 fw-bold mb-4 text-dark lh-sm">
                {noticia.titulo}
              </h1>

              {/* Meta information */}
              <div className="d-flex align-items-center gap-4 text-muted small pb-4 mb-4 border-bottom">
                <div className="d-flex align-items-center gap-2">
                  <FaCalendarAlt className="text-warning" />
                  <span>{noticia.created_at ? new Date(noticia.created_at).toLocaleDateString() : "Recente"}</span>
                </div>
              </div>

              {/* Featured Image */}
              {noticia.foto && (
                <div className="mb-5 rounded-4 overflow-hidden shadow-sm bg-light" style={{ maxHeight: '450px' }}>
                  <img 
                    src={noticia.foto} 
                    alt={noticia.titulo} 
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              )}

              {/* Short Description / Lead */}
              {noticia.descricao && (
                <p className="lead fw-medium text-secondary mb-4">
                  {noticia.descricao}
                </p>
              )}

              {/* Bottom Share / Return */}
              <div className="d-flex align-items-center justify-content-between pt-5 mt-5 border-top">
                <Link to="/noticias" className="btn btn-outline-dark rounded-pill px-4 d-flex align-items-center gap-2">
                  <FaArrowLeft /> Outras Notícias
                </Link>
                
                <button 
                  onClick={async () => {
                    try {
                      if (navigator.share) {
                        await navigator.share({ title: noticia.titulo, url: window.location.href });
                      } else {
                        await navigator.clipboard.writeText(window.location.href);
                        alert("Link copiado para a área de transferência!");
                      }
                    } catch (err) {
                      if (err.name !== 'AbortError') {
                        navigator.clipboard.writeText(window.location.href);
                        alert("Link copiado para a área de transferência!");
                      }
                    }
                  }}
                  className="btn btn-dark text-warning rounded-pill px-4 d-flex align-items-center gap-2"
                >
                  <FaShareAlt /> Partilhar
                </button>
              </div>

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default NoticiaDetalhes;